/* Spacing scale (4px base) and border radius tokens */

export const spacing = {
  // Numeric scale
  0: '0',
  0.5: '0.125rem',    // 2px
  1: '0.25rem',       // 4px
  1.5: '0.375rem',    // 6px
  2: '0.5rem',        // 8px
  2.5: '0.625rem',    // 10px
  3: '0.75rem',       // 12px
  3.5: '0.875rem',    // 14px
  4: '1rem',          // 16px
  5: '1.25rem',       // 20px
  6: '1.5rem',        // 24px
  7: '1.75rem',       // 28px
  8: '2rem',          // 32px
  9: '2.25rem',       // 36px
  10: '2.5rem',       // 40px
  11: '2.75rem',      // 44px
  12: '3rem',         // 48px
  14: '3.5rem',       // 56px
  16: '4rem',         // 64px
  20: '5rem',         // 80px
  24: '6rem',         // 96px

  // Semantic spacing
  pageX: '1.5rem',
  pageY: '1.5rem',
  cardPadding: '1.5rem',
  sectionGap: '1.5rem',
  elementGap: '1rem',
  formGap: '1rem',
  tableCellPadding: '0.75rem 1rem',
  buttonPaddingSm: '0.375rem 0.75rem',
  buttonPaddingMd: '0.5rem 1rem',
  buttonPaddingLg: '0.625rem 1.25rem',
  inputPaddingSm: '0.375rem 0.625rem',
  inputPaddingMd: '0.5rem 0.75rem',
  inputPaddingLg: '0.625rem 0.875rem',
} as const;

/**
 * Raios alinhados ao "Core Enterprise Logic": 0.125rem (2px) em elementos densos,
 * 0.25rem (4px) em inputs e botoes, 0.5rem (8px) em cards e modais, pill em tags
 * de status. A escala anterior (4/6/8/12px) era cerca de duas vezes maior e
 * deixava a interface visivelmente mais arredondada que as 128 telas de
 * referencia.
 */
export const borderRadius = {
  none: '0',
  sm: '2px',
  md: '4px',
  lg: '4px',
  xl: '8px',
  full: '9999px',
} as const;

export type SpacingTokens = typeof spacing;
export type BorderRadiusTokens = typeof borderRadius;
